import { ImpAnimatedBanner } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/ImpAnimatedBanner";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { observer } from "mobx-react";
import React from "react";

const FaireValuesBannerBase: React.FC = () => {
  const { inProductMessagingBanners } = usePromoBanners();

  if (inProductMessagingBanners?.length) {
    return <ImpAnimatedBanner banners={inProductMessagingBanners} />;
  }

  return null;
};

export const FaireValuesBanner = observer(FaireValuesBannerBase);
